import request from './request'

// 认证
export const login = data => request.post('/auth/login', data)
export const getInfo = () => request.get('/auth/info')

// 账号管理
export const getAdminUsers = params => request.get('/admin_users', { params })
export const createAdminUser = data => request.post('/admin_users/save', data)
export const updateAdminUser = (id, data) => request.post('/admin_users/update', { id, ...data })
export const deleteAdminUser = id => request.post('/admin_users/delete', { id })

// 供应商
export const getSuppliers = params => request.get('/suppliers', { params })
export const getAllSuppliers = () => request.get('/suppliers/all')
export const createSupplier = data => request.post('/suppliers/save', data)
export const updateSupplier = (id, data) => request.post('/suppliers/update', { id, ...data })
export const deleteSupplier = id => request.post('/suppliers/delete', { id })

// 产品
export const getProducts = params => request.get('/products', { params })
export const getProductDetail = id => request.get('/products/detail', { params: { id } })
export const createProduct = data => request.post('/products/save', data)
export const updateProduct = (id, data) => request.post('/products/update', { id, ...data })
export const deleteProduct = id => request.post('/products/delete', { id })

// 规格
export const createSpec = (productId, data) => request.post('/specs/save', { product_id: productId, ...data })
export const updateSpec = (id, data) => request.post('/specs/update', { id, ...data })
export const deleteSpec = id => request.post('/specs/delete', { id })

// 规格供应商报价
export const getSpecPrices = specId => request.get('/spec_prices', { params: { spec_id: specId } })
export const saveSpecPrice = (specId, data) => request.post('/spec_prices/save', { spec_id: specId, ...data })
export const deleteSpecPrice = id => request.post('/spec_prices/delete', { id })

// 客户
export const getCustomers = params => request.get('/customers', { params })
export const getAllCustomers = () => request.get('/customers/all')
export const createCustomer = data => request.post('/customers/save', data)
export const updateCustomer = (id, data) => request.post('/customers/update', { id, ...data })
export const deleteCustomer = id => request.post('/customers/delete', { id })

// 报价单
export const getQuotations = params => request.get('/quotations', { params })
export const getQuotationDetail = id => request.get('/quotations/detail', { params: { id } })
export const createQuotation = data => request.post('/quotations/save', data)
export const updateQuotation = (id, data) => request.post('/quotations/update', { id, ...data })
export const updateQuotationStatus = (id, status) => request.post('/quotations/status', { id, status })
export const updateActualCost = (id, data) => request.post('/quotations/actualcost', { id, ...data })
export const deleteQuotation = id => request.post('/quotations/delete', { id })

// 订单
export const getOrders = params => request.get('/orders', { params })
export const getOrderDetail = id => request.get('/orders/detail', { params: { id } })
export const createOrder = data => request.post('/orders/save', data)
export const updateOrder = (id, data) => request.post('/orders/update', { id, ...data })
export const importOrderFromQuotation = data => request.post('/orders/import', data)
export const updateOrderActualCost = (id, data) => request.post('/orders/actualcost', { id, ...data })
export const updateOrderStatus = (id, status) => request.post('/orders/status', { id, status })
export const deleteOrder = id => request.post('/orders/delete', { id })
export const getOrderMonthlyStats = () => request.get('/orders/monthly_stats')
